import { useEffect } from "react";

// The caregiver legal pages duplicate documents the marketing site already
// ranks for at kinbridgehealth.com. Point each app legal route's canonical at
// the marketing equivalent so there is one authoritative copy, and give each
// route a unique <title>. CloudFront cannot do this (a single response-headers
// policy would point every path at the same target), so it is done here at the
// router level — Google renders SPA JS and reads the injected canonical.
export const MARKETING_BASE = "https://kinbridgehealth.com";

export function useCanonical(href, title) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let link = document.querySelector('link[rel="canonical"]');
    const created = !link;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    const prevHref = link.getAttribute("href");
    if (href) link.setAttribute("href", href);

    return () => {
      document.title = prevTitle;
      if (created) {
        link.remove();
      } else if (prevHref) {
        link.setAttribute("href", prevHref);
      } else {
        link.removeAttribute("href");
      }
    };
  }, [href, title]);
}

// Self-referencing canonical for the indexable caregiver pages (/, /features/:slug):
// the page is its own authoritative copy, so the canonical points at the current
// origin + path (production in prod, preview in preview — genuinely self-referencing).
export function useSelfCanonical(title) {
  const href = typeof window !== "undefined" ? window.location.origin + window.location.pathname : undefined;
  useCanonical(href, title);
}
